<div class="container">
  <div
    class="offset-sm-1 col-sm-10 pt-5 webview text-center"
    [@flyInOut]="'in'"
  >
    <h1 class="text-center font-weight-normal-calibre pb-4 questxt">
      {{ question }}
    </h1>
    <div class="col-sm-6 col-md-6 col-xl-4 m-auto px-0">
      <div class="form-group mt-3 mb-0" style="margin-bottom: 0px !important">
        <input
          type="text"
          numbersOnly
          min="1"
          maxlength="5"
          placeholder="sqft"
          oninput="validity.valid||(value='');"
          (keydown.space)="$event.preventDefault()"
          class="form-control"
          [(ngModel)]="sqft_size"
          (keyup)="enableButton()"
          (keyup.enter)="next()"
        />
      </div>
      <p class="m-0 text-muted" style="font-size: 18px">sqft</p>
    </div>
    <button *ngIf="showbutton" 
      class="btn next mr-2 ml-2 disabledButton mt-4 font22 text-uppercase"
      [ngClass]="{ sectbtn: user_bot }"
      (click)="next()"
    >
      Next
    </button>
    <!-- <p class="text-success mt-2">{{questionObj.tip}}</p> -->
    <div class="mt-5">
      <div
        class="m-auto col-sm-12 col-md-6 col-xl-6 blockbg boxclr text-center"
      >
        <img src="assets/images/flash.png" class="mb-1" />
        <p class="text-center tiphead">FUN FACT</p>
        <p class="text-center tipmes">{{ questionObj.tip }}</p>
        <!-- <p class="text-center font-weight-bold">FUN FACT<br>
                <a class="font-weight-normal">{{questionObj.tip}}</a></p> -->
      </div>
    </div>
  </div>
</div>
<div class="container mobileview mt-4 px-0" [attr.id]="questionObj._id">
  <div class="d-flex h-100 row col-sm-12 pr-0">
    <div class="justify-content-center align-self-center col-sm-3 col-3 pl-0">
      <img style="width: 100%" src="assets/images/signimg.jpg" />
    </div>
    <div class="col-sm-9 col-9 px-0 my-auto">
      <div class="arrow_box">
        <h1 class="questionMob text-left">{{ question }}</h1>
      </div>
    </div>
  </div>
  <div class="row" style="width: 98%;">
    <div class="col-12">
      <div class="col-9 offset-col-3 px-0 d-flex flex-wrap pull-right">
        <div class="col-8 px-0">
          <form #f="ngForm" (ngSubmit)="goNext()" novalidate>
            <div class="form-group">
              <input
                type="tel"
                numbersOnly
                min="1"
                maxlength="5"
                name="sqft"
                id="sqft_s"
                step="any"
                (input)="enableButton()"
                (keydown.space)="$event.preventDefault()"
                placeholder="sqft"
                class="form-control"
                [(ngModel)]="sqft_size"
                
                (onkeydown)="showTip = false"
                (keyup.enter)="goNext(); $event.target.blur()"
              />
            </div>
          </form>
        </div>
        <div class="col-2 pr-0">
          <p class="text-muted mt-1">sqft</p>
        </div>
      </div>
    </div>
    <div class="clear"></div>
    <div class="col-12">
      <div style="width: 100%;">
      <div class="pr-3" style="text-align: right">
        <div *ngIf="user_bot" class="ash_box text-right mb-3">
          <h1 class="ansMob text-right">{{ sqft_size }} sqft</h1>
        </div>
      </div>
    </div>

   
    </div>

    <div class="clear"></div>
  </div>
  <!-- <div class="col-12">

    <button 
    class="btn next mr-2 ml-2 disabledButton mt-4 font22 text-uppercase"
    [ngClass]="{ sectbtn: user_bot }"
    (click)="goNext()"
  >
    Next
  </button>
  </div> -->


    <div class="col-12 text-center" style="width: 98%;">
      <a href="javascript:void(0);" (click)="goNext()">
        <button
          class="btn mr-2 ml-2 my-3 disabledButton font20 px-4"
          [ngClass]="{ sectbtn: user_bot }"
        >
        Next
        </button>
      </a>
    </div>



  <div class="col-12" style="width: 97%;">
    <div class="blockbg boxclr p-2">
      <img
        src="assets/images/flash.png"
        class="mb-1"
        style="margin-left: 48%"
      />
      <p class="text-center tiphead">FUN FACT</p>
      <p class="text-center tipmes">{{ questionObj.tip }}</p>
      <!-- <p class="text-center font-weight-bold">FUN FACT<br>
                    <a class="font-weight-normal">{{questionObj.tip}}</a></p> -->
    </div>
  </div>
</div>
<!-- <div class="btm-process webview">
    <div class="text-center" *ngIf="!messagetype">
        <span><img src="assets/images/active11.png"></span>
        <h4 class="clr333 processtxt">15% Completed</h4>
    </div>
    <div class="text-center" *ngIf="messagetype">
        <span><img src="assets/images/active7.png"></span>
        <h5 class="clr333 processtxt">35% Completed</h5>
    </div>
</div> -->
